import React, { FC } from 'react';
import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { UpperTitle } from 'components/atoms';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(10, 0),
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(15, 0),
      },
    },
    title: {
      margin: theme.spacing(2, 0, 3),
    },
    text: {
      marginBottom: theme.spacing(4),
    },
    boldText: {
      fontWeight: 700,
    },
  });
});

const listItems = [
  '4 billion people worldwide use the internet, almost half of them shop online, and the e-commerce market is constantly growing. Therefore, for entrepreneurs, creating and promoting a website has long been an excellent way to expand their business and discover new forms of monetization.\n',
  'Digital marketing refers to advertising distributed over a digital channel such as search engines, websites, social media, direct mailing or newsletter, and mobile apps. While this covers a wide range of marketing activities that are not always used, we work with the most lucrative solutions and services.',
];

const DigitalMarketingBlock: FC = () => {
  const classes = useStyles();
  return (
    <Container fixed>
      <Grid container justifyContent="space-between" className={classes.root}>
        <Grid lg={5} item>
          <UpperTitle text="Effective promotion" />
          <Typography variant="h2" className={classes.title}>
            Digital{' '}
            <Typography variant="h2" component="span" color="primary">
              marketing
            </Typography>
          </Typography>
        </Grid>
        <Grid lg={7} item>
          {listItems.map((item) => (
            <Typography key={item} variant="body2" className={classes.text}>
              {item}
            </Typography>
          ))}
          <Typography variant="body2" className={classes.boldText}>
            At US Software Solutions, we focus on promoting brands using the internet and other forms of digital communication. It
            Includes SEO, social networks, and online advertising.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DigitalMarketingBlock;
